// extracted by css-extract-rspack-plugin
export default {"link":"_cd424857"};